const commonCare = [
  "Follow the care label attached to the garment.",
  "Wash with similar colours.",
  "Reshape while damp and air dry where possible.",
];

const productData = [
  {
    id: 1,
    name: "Harbour Chore Jacket",
    category: "Jackets",
    price: "168.00",
    image: "/assets/products/01-harbour-chore-jacket.jpg",
    imageLabel: "HCJ",
    palette: ["#173f37", "#cfe1d7", "#f5efe4"],
    size: ["XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Deep Green", "Stone"],
    material: "Cotton twill",
    description: ["A relaxed everyday layer with a clean collar, roomy patch pockets and an easy straight fit."],
    Features: ["Relaxed fit", "Three patch pockets", "Button front", "Unlined construction"],
    washcare: commonCare,
  },
  {
    id: 2,
    name: "Arc Pleat Trouser",
    category: "Trousers",
    price: "124.00",
    image: "/assets/products/02-arc-pleat-trouser.jpg",
    imageLabel: "APT",
    palette: ["#27384a", "#b8c8d6", "#f4f0e7"],
    size: ["26", "28", "30", "32", "34", "36", "38"],
    colors: ["Ink", "Chalk"],
    material: "Cotton blend",
    description: ["A softly structured trouser with a single front pleat, a generous leg and a subtle taper at the ankle."],
    Features: ["Relaxed tapered leg", "Single front pleat", "Side pockets", "Button fastening"],
    washcare: commonCare,
  },
  {
    id: 3,
    name: "Drift Drawstring Trouser",
    category: "Trousers",
    price: "118.00",
    image: "/assets/products/03-drift-drawstring-trouser.jpg",
    imageLabel: "DDT",
    palette: ["#714737", "#d8b6a5", "#f2e9dc"],
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Clay", "Navy"],
    material: "Washed cotton",
    description: ["An easy pull-on trouser designed around comfort, with a flexible waist and a balanced wide-leg shape."],
    Features: ["Elasticated waist", "Internal drawcord", "Wide leg", "Two side pockets"],
    washcare: commonCare,
  },
  {
    id: 4,
    name: "Field Overshirt",
    category: "Shirts",
    price: "106.00",
    image: "/assets/products/04-field-overshirt.jpg",
    imageLabel: "FOS",
    palette: ["#5e633b", "#ccd0aa", "#f4f1e6"],
    size: ["XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Moss", "Indigo"],
    material: "Brushed cotton",
    description: ["A mid-weight shirt that works as a light layer, finished with a square hem and practical chest pockets."],
    Features: ["Regular fit", "Two chest pockets", "Square hem", "Button cuffs"],
    washcare: commonCare,
  },
  {
    id: 5,
    name: "Fold Day Bag",
    category: "Bags",
    price: "92.00",
    image: "/assets/products/05-fold-day-bag.jpg",
    imageLabel: "FDB",
    palette: ["#4b3428", "#cfb79f", "#f3eadf"],
    size: ["One size"],
    colors: ["Cocoa", "Natural"],
    material: "Heavy cotton canvas",
    description: ["A useful everyday carry with a wide opening, internal pocket and adjustable shoulder strap."],
    Features: ["Adjustable strap", "Internal slip pocket", "Magnetic closure", "Reinforced base"],
    washcare: ["Spot clean only.", "Air dry away from direct heat."],
  },
  {
    id: 6,
    name: "Coast Strap Sandal",
    category: "Footwear",
    price: "88.00",
    image: "/assets/products/06-coast-strap-sandal.jpg",
    imageLabel: "CSS",
    palette: ["#85553e", "#e0c1a2", "#f6eee2"],
    size: ["EU36", "EU37", "EU38", "EU39", "EU40", "EU41", "EU42"],
    colors: ["Tobacco", "Black"],
    material: "Textile upper, rubber sole",
    description: ["A lightweight warm-weather sandal with adjustable straps and a cushioned, flexible footbed."],
    Features: ["Adjustable straps", "Cushioned footbed", "Flexible outsole", "Lightweight construction"],
    washcare: ["Wipe clean with a damp cloth.", "Air dry naturally."],
  },
  {
    id: 7,
    name: "Market Zip Tote",
    category: "Bags",
    price: "84.00",
    image: "/assets/products/07-market-zip-tote.jpg",
    imageLabel: "MZT",
    palette: ["#7e2833", "#d59ca4", "#f4e8e5"],
    size: ["One size"],
    colors: ["Berry", "Graphite"],
    material: "Recycled woven fabric",
    description: ["A soft, packable tote with long handles and a zipped top for commutes, errands and weekends away."],
    Features: ["Zip closure", "Long shoulder handles", "Internal pocket", "Fold-flat design"],
    washcare: ["Spot clean only.", "Air dry naturally."],
  },
  {
    id: 8,
    name: "Common Two-Button Jacket",
    category: "Jackets",
    price: "194.00",
    image: "/assets/products/08-common-two-button-jacket.jpg",
    imageLabel: "CTJ",
    palette: ["#292b2d", "#a8aaad", "#efece5"],
    size: ["XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Charcoal", "Sand"],
    material: "Cotton-linen blend",
    description: ["A softly tailored jacket with natural shoulders and enough room to wear over a shirt or fine knit."],
    Features: ["Relaxed fit", "Two-button front", "Three outer pockets", "Half lining"],
    washcare: ["Professional dry clean only.", "Cool iron if required."],
  },
  {
    id: 9,
    name: "Sunline Camp Shirt",
    category: "Shirts",
    price: "98.00",
    image: "/assets/products/09-sunline-camp-shirt.jpg",
    imageLabel: "SCS",
    palette: ["#d39624", "#f2d687", "#f8f0dc"],
    size: ["XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Saffron", "Sky"],
    material: "Lightweight cotton",
    description: ["A breezy short-sleeve shirt with an open collar, a straight hem and a simple single pocket."],
    Features: ["Relaxed fit", "Open collar", "Chest pocket", "Straight hem"],
    washcare: commonCare,
  },
  {
    id: 10,
    name: "Canvas Low Trainer",
    category: "Footwear",
    price: "78.00",
    image: "/assets/products/10-canvas-low-trainer.jpg",
    imageLabel: "CLT",
    palette: ["#315b69", "#a9ced4", "#f2ede2"],
    size: ["EU37", "EU38", "EU39", "EU40", "EU41", "EU42", "EU43", "EU44", "EU45"],
    colors: ["Sea Blue", "Ecru"],
    material: "Cotton canvas upper, rubber sole",
    description: ["A straightforward lace-up trainer with a low profile, durable canvas upper and contrast rubber sole."],
    Features: ["Canvas upper", "Rubber toe cap", "Cushioned insole", "Metal eyelets"],
    washcare: ["Wipe clean with a damp cloth.", "Do not machine wash."],
  },
  {
    id: 11,
    name: "Six-Panel Utility Cap",
    category: "Accessories",
    price: "46.00",
    image: "/assets/products/11-six-panel-utility-cap.jpg",
    imageLabel: "SUC",
    palette: ["#38614e", "#a9c1b1", "#eeeadd"],
    size: ["One size"],
    colors: ["Fern", "Black"],
    material: "Cotton twill",
    description: ["A low-profile six-panel cap with stitched ventilation eyelets and a simple adjustable back."],
    Features: ["Six-panel construction", "Adjustable back", "Ventilation eyelets", "Curved peak"],
    washcare: ["Hand wash cool.", "Reshape and air dry."],
  },
  {
    id: 12,
    name: "Packable Shade Hat",
    category: "Accessories",
    price: "52.00",
    image: "/assets/products/12-packable-shade-hat.jpg",
    imageLabel: "PSH",
    palette: ["#4e4b75", "#bbb5db", "#f0ebf3"],
    size: ["S/M", "L/XL"],
    colors: ["Dusk", "Olive"],
    material: "Recycled nylon",
    description: ["A soft-brim sun hat that folds into a pocket or bag and springs back into shape when needed."],
    Features: ["Packable brim", "Breathable lining", "Lightweight fabric", "Internal size adjuster"],
    washcare: ["Hand wash cool.", "Air dry away from direct heat."],
  },
  {
    id: 13,
    name: "Tide Shell Jacket",
    category: "Jackets",
    price: "142.00",
    image: "/assets/products/13-tide-shell-jacket.jpg",
    size: ["XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Ocean Blue", "Graphite"],
    material: "Recycled nylon",
    description: ["A lightweight shell layer with a high collar, clean concealed closure and an adjustable hem for changing conditions."],
    Features: ["Relaxed fit", "High stand collar", "Concealed front zip", "Two slanted pockets", "Drawcord hem", "Elasticated cuffs"],
    washcare: ["Wash cool on a gentle cycle.", "Do not use fabric softener.", "Air dry naturally."],
  },
  {
    id: 14,
    name: "Workshop Utility Vest",
    category: "Vests",
    price: "96.00",
    image: "/assets/products/14-workshop-utility-vest.jpg",
    size: ["XS", "S", "M", "L", "XL", "XXL"],
    colors: ["Sand", "Deep Green"],
    material: "Heavy cotton canvas",
    description: ["A straightforward utility vest designed for easy layering, with a clean V neck and three useful patch pockets."],
    Features: ["Relaxed straight fit", "Button front", "One chest pocket", "Two lower patch pockets", "Bound armholes"],
    washcare: commonCare,
  },
  {
    id: 15,
    name: "Channel Knit Polo",
    category: "Knitwear",
    price: "112.00",
    image: "/assets/products/15-channel-knit-polo.jpg",
    size: ["XS", "S", "M", "L", "XL"],
    colors: ["Cobalt", "Ecru"],
    material: "Cotton knit",
    description: ["A soft short-sleeve polo with fine vertical ribbing, an open collar and a relaxed, easy drape."],
    Features: ["Relaxed fit", "Open collar", "Fine rib knit", "Straight hem", "Short sleeves"],
    washcare: ["Hand wash cool.", "Reshape while damp.", "Dry flat."],
  },
  {
    id: 16,
    name: "Utility Walking Short",
    category: "Shorts",
    price: "82.00",
    image: "/assets/products/16-utility-walking-short.jpg",
    size: ["28", "30", "32", "34", "36", "38"],
    colors: ["Taupe", "Navy"],
    material: "Cotton ripstop",
    description: ["A relaxed above-knee short in lightweight ripstop, balancing a clean front with practical everyday pockets."],
    Features: ["Relaxed fit", "Button and zip fly", "Two slanted side pockets", "Two rear welt pockets", "Above-knee length"],
    washcare: commonCare,
  },
  {
    id: 17,
    name: "Transit Rolltop Backpack",
    category: "Bags",
    price: "108.00",
    image: "/assets/products/17-transit-rolltop-backpack.jpg",
    size: ["One size"],
    colors: ["Slate", "Black"],
    material: "Recycled woven fabric",
    description: ["A structured daily backpack with a roll-top closure, padded straps and quick-access external storage."],
    Features: ["Roll-top buckle closure", "Padded shoulder straps", "Front zip pocket", "Side bottle pocket", "Reinforced base"],
    washcare: ["Spot clean only.", "Air dry away from direct heat."],
  },
  {
    id: 18,
    name: "Ridge Leather Derby",
    category: "Footwear",
    price: "158.00",
    image: "/assets/products/18-ridge-leather-derby.jpg",
    size: ["EU39", "EU40", "EU41", "EU42", "EU43", "EU44", "EU45"],
    colors: ["Dark Brown", "Black"],
    material: "Leather upper, rubber outsole",
    description: ["A plain-toe derby with open lacing, a softly rounded profile and a sturdy outsole for everyday wear."],
    Features: ["Four-eyelet open lacing", "Plain rounded toe", "Low stacked heel", "Welted edge", "Rubber outsole"],
    washcare: ["Wipe clean after wear.", "Use a suitable leather conditioner.", "Air dry naturally if damp."],
  },
  {
    id: 19,
    name: "Woven Web Belt",
    category: "Accessories",
    price: "42.00",
    image: "/assets/products/19-woven-web-belt.jpg",
    size: ["90 cm", "105 cm", "120 cm"],
    colors: ["Navy", "Olive"],
    material: "Cotton webbing, metal hardware",
    description: ["A dense woven belt with a simple adjustable buckle and clean metal end tip."],
    Features: ["Adjustable fit", "Brushed metal buckle", "Metal end tip", "Dense woven webbing"],
    washcare: ["Spot clean only.", "Keep metal hardware dry."],
  },
  {
    id: 20,
    name: "Everyday Rib Socks",
    category: "Accessories",
    price: "24.00",
    image: "/assets/products/20-everyday-rib-socks.jpg",
    size: ["S/M", "L/XL"],
    colors: ["Ecru", "Charcoal"],
    material: "Cotton blend",
    description: ["A comfortable mid-calf sock with a substantial rib knit and softly reinforced heel and toe."],
    Features: ["Mid-calf length", "Rib-knit leg", "Comfort cuff", "Reinforced heel and toe", "Sold as one pair"],
    washcare: ["Wash cool with similar colours.", "Do not bleach.", "Air dry where possible."],
  },
];

export default productData;
